import { Button } from 'react-bootstrap';
import { Field, InjectedFormProps } from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import React = require('react');
import { useState } from 'react';
import { IQuoteActions, IQuoteState } from '../../../../../../services/quote/models';
import { FaExclamationTriangle } from 'react-icons/fa';
import QuoteIcons from '../../../Components/Icon/QuoteIcons';

interface IVoucherProps extends InjectedFormProps {
  quoteState: IQuoteState;
  campaignCode: any;
  applyCallback?: any;
  actions: {
    quote: IQuoteActions;
  };
}

export const Voucher = ({ quoteState, actions, campaignCode, applyCallback = null }: IVoucherProps) => {

  const [disableButton, setDisableButton] = useState(false);

  const checkVoucherCode = () => {
    setDisableButton(true)
    Promise.resolve(actions.quote.checkVoucherCode(campaignCode)).then(() => {
      setDisableButton(false)
      if (applyCallback) {
        applyCallback()
      }
    })
  }

  const renderButtonMessage = () => {
    if (quoteState.voucherCodeStatus === 'success' && quoteState.regexVoucherCode) {
      return <span>APPLIED</span>;
    }

    if (quoteState.voucherCodeStatus === 'success') {
      return <span>APPLIED</span>;
    }

    return <span>CHECK</span>;
  }

  return (
    <div>
      <div className={'voucher-code-container'}>
        <div>
          <div className="voucher-code">
            <div className={'flex-container pb-15'}>
              <div><QuoteIcons name={'Money'} color={'green'}/></div>
              <div className={'primary-text pl-15'}> Get a discount</div>
            </div>
            <div>If you have a voucher code or an active Admiral policy you can get a discount.</div>
            <ul>
              <li className="list">Adding a policy number will give you 10% off</li>
              <li className="list">The active policy must be for Admiral Car, Van, Home or Landlord insurance</li>
              <li className="list">Only one discount can be applied per policy</li>
            </ul>
          </div>
        </div>
        <div className={'flex-container voucher'}>
          <div className={'flex--50 pb-15'}>Voucher code or policy number</div>
          <div className={'flex--50 pb-15'}>
            <div className={'flex-container voucher'}>
              <div className={quoteState.voucherCodeStatus === 'error' && 'has-error'} style={{ maxWidth: '180px' }}>
                <Field
                  name="campaignCode"
                  component={FieldFormControl}
                  disabled={null !== quoteState.campaignCode || quoteState.voucherCodeStatus === 'success'}
                  type={quoteState.voucherCodePreventDisplay ? 'password' : 'text'}
                />
              </div>
              <div style={{ marginLeft: '15px' }}>
                <Button
                  className={quoteState.voucherCodeStatus === 'success' ? 'admiral-secondary-btn' : 'admiral-primary-btn'}
                  onClick={checkVoucherCode}
                  disabled={quoteState.voucherCodeStatus === 'success' || disableButton}
                >
                  {renderButtonMessage()}
                </Button>
              </div>
            </div>
          </div>

        </div>

        {quoteState.voucherCodeStatus === 'error' && (
          <div className={'error-box'}>
            <FaExclamationTriangle/> {quoteState.voucherCodeMessage}
          </div>
        )}
      </div>
    </div>
  )
}
